import React from 'react';
import { TableRowMode } from 'shared/Table/Table.models';
import { ISowDataListItem } from '@EngagementsSowData/sowData.model';
import { getTableRowModeBoolean } from 'shared/Table/Actions/utilities';
import { useActionsPermissions } from 'core/hooks/useActionsPermissions';
import { useTableActiveRowContext } from 'shared/Table/TableActiveRowContext';
import CommentsRowSidebar from 'pages/WirelineEngagements/shared/CommentsRowSidebar';
import { ACTIONS_WIRELINE_ENGAGEMENT_SOW_PATHS } from 'core/models/actionsPermissions';
import { COMMENTS_ORDER_CATEGORY } from 'pages/WirelineEngagements/shared/CommentsRowSidebar/constants';

const {
  GENERAL,
  BILLING,
} = COMMENTS_ORDER_CATEGORY;

const {
  COMMENTS_GENERAL_GET,
  COMMENTS_BILLING_GET,
  COMMENTS_GENERAL_CREATE,
  COMMENTS_BILLING_CREATE,
} = ACTIONS_WIRELINE_ENGAGEMENT_SOW_PATHS;

const actionsPaths = {
  isAvailableGetGeneralComments: COMMENTS_GENERAL_GET,
  isAvailableGetBillingComments: COMMENTS_BILLING_GET,
  isAvailableCreateGeneralComments: COMMENTS_GENERAL_CREATE,
  isAvailableCreateBillingComments: COMMENTS_BILLING_CREATE,
};

const CommentsSidebar = () => {
  const {
    activeRowId,
    activeRowMode,
    secondarySidebarMode,
    cleanActiveRow,
    setSecondarySidebarMode,
  } = useTableActiveRowContext<ISowDataListItem>();

  const {
    isAvailableGetGeneralComments,
    isAvailableGetBillingComments,
    isAvailableCreateGeneralComments,
    isAvailableCreateBillingComments,
  } = useActionsPermissions(actionsPaths);

  const { isCommentMode } = getTableRowModeBoolean(activeRowMode);

  const isCommentsInsideEditOpen = secondarySidebarMode === TableRowMode.COMMENT;

  const isActiveRow = isCommentMode || isCommentsInsideEditOpen;
  const commentsActiveRowId = (isActiveRow ? activeRowId : null) as string | number | null;

  const availableVissibleCategories = {
    [GENERAL]: isAvailableGetGeneralComments,
    [BILLING]: isAvailableGetBillingComments,
  };

  const availableCreateCategories = {
    [GENERAL]: isAvailableCreateGeneralComments,
    [BILLING]: isAvailableCreateBillingComments,
  };

  return (
    <CommentsRowSidebar
      title="Order Comments"
      activeRowId={commentsActiveRowId}
      availableCreateCategories={availableCreateCategories}
      availableVissibleCategories={availableVissibleCategories}
      isCommentsInsideEditOpen={isCommentsInsideEditOpen}
      cleanActiveRow={cleanActiveRow}
      setSecondarySidebarMode={setSecondarySidebarMode}
    />
  );
};

export default CommentsSidebar;
